import service from "@/utils/request";

// 员工详情
export const staffDetail = (params: { staff_id: number }) => {
  return service({
    url: "/api/v1/staff/detail",
    method: "get",
    params,
  });
};
//员工角色对应菜单
export const relationMenu = (params: { role_ids: number[] }) => {
  return service({
    url: "/api/v1/roles/relation/menu",
    method: "get",
    params,
  });
};
//员工角色对应菜单
export const roleslist = () => {
  return service({
    url: "/api/v1/roles/list",
    method: "get",
  });
};
//编辑员工
export interface staffInfoData {
  name: number;
  mobile: string;
  avatar?: string;
  sex?: number;
  subjects?: number[];
  // is_teach: number;
  // edu_teacher: number;
  // course_adviser: number;
  // is_live: number;
  teach_machine: number;
  roles: number[];
  remark: string;
  book_auth: number;
  book_ids: number[];
  area_code: string;
  job_ids?: number[];
  resting_time?: number[];
  full_time?: number;
}
export interface modifyInfoData extends staffInfoData {
  staff_id: number;
}
export interface createInfoData extends staffInfoData {
  staff_id?: number;
}
export const modifyInfo = (data: modifyInfoData) => {
  return service({
    url: "/api/v1/staff/modify/info",
    method: "post",
    data,
  });
};
//修改员工在职状态
export const modifyStatusClick = (data: {
  staff_id: number;
  on_job: number;
}) => {
  return service({
    url: "/api/v1/staff/modify/status",
    method: "post",
    data,
  });
};
// 删除员工前置检查
export const beforeStaffDel = (params: { staff_id: number }) => {
  return service({
    url: "/api/v1/staff/del/before_check",
    method: "get",
    params,
  });
};
//删除员工
export const staffdel = (data: { staff_id: number }) => {
  return service({
    url: "/api/v1/staff/del",
    method: "post",
    data,
  });
};
//添加员工
export const staffcreate = (data: createInfoData) => {
  return service({
    url: "/api/v1/staff/create",
    method: "post",
    data,
  });
};
//添加员工
export const rolesDataAuthority = (data: { roles: [] }) => {
  return service({
    url: "/api/v1/roles/data_authority",
    method: "post",
    data,
  });
};
//获取员工默认头像
export const defaultImgApi = () => {
  return service({
    url: "/api/v1/staff/default/img",
    method: "get",
  });
};

// 获取员工激活链接
export const getStaffActivateLinkApi = (params: { staff_id: number }) => {
  return service({
    url: "/api/v1/staff/activate/link_create",
    method: "get",
    params,
  });
};
// 生成员工关联码
export const createStaffRelateCodeApi = (params: { staff_id: number }) => {
  return service({
    url: "/api/v1/staff/relation/code_create",
    method: "get",
    params,
  });
};
// 员工关联码内容
export const getStaffRelateCodeDetailApi = (params: { code: string }) => {
  return service({
    url: "/api/v1/staff/relation/code_detail",
    method: "get",
    params,
  });
};
